import React from 'react';

const VendorDashboard = () => {
  return (
    <div>
      <h1>Vendor Dashboard</h1>
      <p>Welcome to the vendor dashboard!</p>
    </div>
  );
};

export default VendorDashboard;